import { render, staticRenderFns } from "./ForthScreen.vue?vue&type=template&id=65d37f62&scoped=true&"
import script from "./ForthScreen.vue?vue&type=script&lang=js&"
export * from "./ForthScreen.vue?vue&type=script&lang=js&"
import style0 from "./ForthScreen.vue?vue&type=style&index=0&id=65d37f62&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d37f62",
  null
  
)

export default component.exports